import { render, staticRenderFns } from "./BajasCobranzaEditar.vue?vue&type=template&id=189e4c30&"
import script from "./BajasCobranzaEditar.vue?vue&type=script&lang=ts&"
export * from "./BajasCobranzaEditar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('189e4c30', component.options)
    } else {
      api.reload('189e4c30', component.options)
    }
    module.hot.accept("./BajasCobranzaEditar.vue?vue&type=template&id=189e4c30&", function () {
      api.rerender('189e4c30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/BajasCobranza/gridActions/BajasCobranzaEditar.vue"
export default component.exports